function validate(value) {
  if (value === undefined || value === '') {
    return true;
  }
  const date = new Date(dateFromMask(value));
  return !isNaN(date.valueOf());
}

function dateToMask(value) {
  if (!value) {
    return value;
  }
  if (value.indexOf('-') === -1) {
    return value;
  }
  const res = value.replace(/-/g, '');
  return res.substr(6, 2) +  res.substr(4, 2)  +  res.substr(0, 4);
}

function dateFromMask(value) {
  if (!value) {
    return value;
  }
  const res = value.replace(/\//g, '');
  return res.substr(4, 4) + '-' + res.substr(2, 2) + '-' + res.substr(0, 2);
}

export default {validate, dateFromMask, dateToMask};



// WEBPACK FOOTER //
// ./src/utils/date.util.js